export default __webpack_public_path__ + "static/media/screen4.e882b3ca.svg";